export const oktaConfig = {
    issuer: process.env.REACT_APP_OKTA_ISSUER,
    redirectUri: `${window.location.origin}/implicit/callback`,
    clientId: 'nike.niketech.returns-ui',
    scopes: ['default', 'openid', 'profile', 'email'],
    pkce: true,
};